module.exports = __webpack_public_path__ + "img/tikok.23028c5e.png";